export default "__VITE_ASSET__60d43708__"